module.exports = __webpack_public_path__ + "img/service-providers-icon.129c55cf.png";